import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MdOutlineAddBox, MdOutlineAssessment } from "react-icons/md";
import { TbFileInvoice } from "react-icons/tb";
import { FaRegFolderOpen } from "react-icons/fa";
import { AiOutlineDashboard } from "react-icons/ai";
import { RiLockPasswordLine } from "react-icons/ri";
import "../index.css";

const MenuSide = ({ openMenu, setOpenMenu, tenantUsername }) => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const activeTab = new URLSearchParams(location.search).get("tab");
  
  const isActiveDashboard =
    location.pathname === `/${tenantUsername}` ||
    location.pathname === `/${tenantUsername}/dashboard`;
  const isActiveCreateTicket = location.pathname.includes("/tickets/add");
  const isActiveTickets =
    (location.pathname.includes("/tickets") &&
      !location.pathname.includes("/tickets/add")) ||
    location.pathname.includes("/tickets/show/");
  
  const isActiveProjects = location.pathname.includes("/projects");

  // إضافة حالة النشاط لصفحة التقارير
  const isActiveReports = location.pathname.includes("/reports");
  
  const isActiveChangePassword =
    location.pathname === `/${tenantUsername}/settings` && activeTab === "password";

  return (
    <div
      className={`z-[100] flex items-center transition-all duration-500 ease-out h-screen primary-bg-color justify-center ${
        openMenu ? "fixed w-10 flex md:w-40 md:relative" : "fixed w-0 hidden md:flex md:w-[52px]"
      }`}
    >
      <ul className="cursor-default flex w-full flex-col gap-5 items-center text-white text-xs">
        <li
          data-title={t("menu.Dashboard")}
          className={`w-full tooltip gap-2 flex items-center relative menu-border-color py-3 ${
            openMenu || "justify-center"
          }`}
        >
          <NavLink
            to={`/${tenantUsername}`}
            className={`flex items-center gap-2 ${isActiveDashboard ? "active" : ""}`}
            end
          >
            <AiOutlineDashboard size={22} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0"></span>
          </NavLink>
        </li>
        <li
          data-title={t("support.menu.createTicket")}
          className={`w-full tooltip gap-2 flex items-center relative menu-border-color py-3 ${
            openMenu || "justify-center"
          }`}
        >
          <NavLink
            to={`/${tenantUsername}/tickets/add`}
            className={`flex items-center gap-2 ${isActiveCreateTicket ? "active" : ""}`}
            end
          >
            <MdOutlineAddBox size={22} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0"></span>
          </NavLink>
        </li>
        <li
          data-title={t("support.menu.tickets")}
          className={`w-full tooltip gap-2 flex items-center relative menu-border-color py-3 ${
            openMenu || "justify-center"
          }`}
        >
          <NavLink
            to={`/${tenantUsername}/tickets`}
            className={`flex items-center gap-2 ${isActiveTickets ? "active" : ""}`}
            end
          >
            <TbFileInvoice size={22} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0"></span>
          </NavLink>
        </li>
        
        {/* مشاريع الشركة (عرض فقط) */}
        <li
          data-title={t("support.menu.projects") || "Projects"}
          className={`w-full tooltip gap-2 flex items-center relative menu-border-color py-3 ${
            openMenu || "justify-center"
          }`}
        >
          <NavLink
            to={`/${tenantUsername}/projects`}
            className={`flex items-center gap-2 ${isActiveProjects ? "active" : ""}`}
          >
            <FaRegFolderOpen size={20} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0"></span>
          </NavLink>
        </li>

        {/* --- إضافة عنصر التقارير الجديد --- */}
        <li
          data-title={t("support.menu.reports") || "Reports"}
          className={`w-full tooltip gap-2 flex items-center relative menu-border-color py-3 ${
            openMenu || "justify-center"
          }`}
        >
          <NavLink
            to={`/${tenantUsername}/reports`}
            className={`flex items-center gap-2 ${isActiveReports ? "active" : ""}`}
            end
          >
            <MdOutlineAssessment size={22} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0"></span>
          </NavLink>
        </li>

        <li
          data-title={t("support.menu.changePassword")}
          className={`w-full tooltip gap-2 flex items-center relative menu-border-color py-3 ${
            openMenu || "justify-center"
          }`}
        >
          <NavLink
            to={`/${tenantUsername}/settings?tab=password`}
            className={`flex items-center gap-2 ${isActiveChangePassword ? "active" : ""}`}
            end
          >
            <RiLockPasswordLine size={22} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0"></span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default MenuSide;
